module.exports = __webpack_public_path__ + "img/Group 133.7dbf19dd.svg";